export const getHeightForNotifyMe = (): number => {
    const WIDTH = window.innerWidth;

    if (WIDTH < 800) return 300;
    if (WIDTH < 1000) return 350;
    if (WIDTH < 1300) return 500;
    if (WIDTH > 1300) return 600;
    return 600;
};
